export const TARGETED_RECONCILIATION_API_URL_CONFIG = {
  GET_ALL: '/targetedReconciliation',
};
